// schema
import * as ISchema from "@schema";
// libraries
import * as React from "react";
import { createFragmentContainer } from "react-relay";
// event-summary-attendees
import { eventSummaryAutopilotFlexFragments } from "./EventSummaryAutopilotFlex.gql";
import { EventSummaryRow as s } from "./EventSummary.styles";
// util
import { EFlex, getFlexFromEvent } from "@util/event-tag.util";
// material-ui
import { Assistant } from "@material-ui/icons";

interface IProps {
  event: ISchema.IEvent;
}
const EventSummaryAutopilotFlexCmpt = ({ event }: { event: ISchema.IEvent }) => {
  const flex = getFlexFromEvent(event, true);

  if (flex === EFlex.Pin) {
    return <span />;
  }
  return (
    <div style={s.container}>
      <Assistant style={s.icon} htmlColor={s.icon.color} />
      <div style={s.text}>
        {flex === EFlex.Day ? "Ok to move within day" : ""}
        {flex === EFlex.Week ? "Ok to move within the week" : ""}
      </div>
    </div>
  );
};

export const EventSummaryAutopilotFlex = createFragmentContainer<IProps>(
  EventSummaryAutopilotFlexCmpt,
  eventSummaryAutopilotFlexFragments,
);
